export namespace ResizeUtils {

  export const needForResize = calculateNeedForResize();

  function getWindowSize() {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }

  export function resizeToFitWidth() {
    const appWagoElement: any = document.getElementsByTagName('app-wago')[0];
    if (!appWagoElement) {
      return;
    }
    const windowSize = getWindowSize();
    const bodyElement = document.body;
    const documentWidth = bodyElement.clientWidth;
    const horizontalScaleRate = windowSize.width / documentWidth;
    if (documentWidth > windowSize.width) {
      appWagoElement.style['transform'] = `scale(${horizontalScaleRate})`;
      appWagoElement.style['transform-origin'] = `top left`;
      const verticalScaleRate = documentWidth / windowSize.width;
      const targetHeight = verticalScaleRate * windowSize.height;
      const targetWidth = verticalScaleRate * windowSize.width;
      appWagoElement.style[`height`] = targetHeight + `px`;
      appWagoElement.style[`width`] = targetWidth + `px`;
    } else {
      appWagoElement.style['transform'] = `none`;
      appWagoElement.style['transform-origin'] = `unset`;
      appWagoElement.style[`height`] = '100%';
      appWagoElement.style[`width`] = '100%';
    }
  }

  function calculateNeedForResize(): boolean {
    if (navigator.userAgent.match(/Android/g)) {
      return true;
    }
    if (!navigator.userAgent.match(/(iPad|iPhone)/g)) {
      return true;
    }
    const windowSize = getWindowSize();
    const bodyElement = document.body;
    const documentWidth = bodyElement.clientWidth;
    return documentWidth > windowSize.width;
  }
}
